import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "chat-messages-page" };
const _hoisted_2 = { class: "chat-messages-content" };
const _hoisted_3 = {
    key: 0,
    class: "loading-overlay"
};
const _hoisted_4 = { class: "card filter-card" };
const _hoisted_5 = { class: "filter-row" };
const _hoisted_6 = { class: "filter-group" };
const _hoisted_7 = { class: "input-with-clear" };
const _hoisted_8 = { class: "filter-group" };
const _hoisted_9 = { class: "filter-group" };
const _hoisted_10 = ["onClick"];
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAdmin } from '@/composables/useAdmin';
import AdminTable from '@/admin/components/AdminTable.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AIChatMessagesPage',
    setup(__props) {
        const route = useRoute();
        const admin = useAdmin();
        const now = new Date();
        const startDate = new Date(now);
        startDate.setDate(now.getDate() - 2);
        const isLoading = ref(false);
        const filters = ref({
            customerId: '',
            fromDate: startDate.toISOString().slice(0, 10),
            fromTime: startDate.toISOString().slice(11, 16),
            toDate: now.toISOString().slice(0, 10),
            toTime: now.toISOString().slice(11, 16),
        });
        const messages = ref([]);
        const customers = ref([]);
        const employers = ref([]);
        const tableColumns = [
            {
                field: 'customerID',
                label: 'Customer ID',
                width: '120px',
                sortable: true
            },
            {
                field: 'employerName',
                label: 'Employer Name',
                width: '200px',
                sortable: true
            },
            {
                field: 'direction',
                label: 'Direction',
                width: '100px',
                sortable: false
            },
            {
                field: 'body',
                label: 'Message',
                width: '3fr',
                sortable: false
            },
            {
                field: 'createDateTime',
                label: 'Created Date Time',
                width: '180px',
                sortable: true,
                type: 'date'
            }
        ];
        const processedMessages = computed(() => {
            return messages.value.map((msg) => {
                const maskedBody = msg.body && typeof msg.body === 'string'
                    ? msg.body.replace(/£\d{1,3}(?:,\d{3})*(?:\.\d{2})?/g, '£***')
                    : msg.body;
                const isTruncated = msg.isTruncated !== false;
                const truncatedBody = maskedBody && maskedBody.length > 500
                    ? `${maskedBody.slice(0, 500)}...`
                    : maskedBody;
                return {
                    ...msg,
                    displayBody: isTruncated ? truncatedBody : maskedBody,
                    isTruncated,
                    isHighlighted: msg.body && msg.body.startsWith("I'd like to talk about"),
                };
            });
        });
        function mergeEmployerIntoMessages() {
            messages.value = messages.value.map((msg) => {
                const customer = customers.value.find((cust) => cust.id === msg.customerID);
                const employerID = customer ? customer.employerID : null;
                const employer = employers.value.find((emp) => emp.id === employerID);
                if (employer && employer.name === 'Money Guided') {
                    return null;
                }
                return {
                    ...msg,
                    employerName: employer ? employer.name : 'Unknown'
                };
            }).filter((msg) => msg !== null);
        }
        function fetchMessages() {
            isLoading.value = true;
            const fromDateTime = new Date(`${filters.value.fromDate}T${filters.value.fromTime}`).toISOString();
            const toDateTime = new Date(`${filters.value.toDate}T${filters.value.toTime}`).toISOString();
            const filterParams = {
                customerId: filters.value.customerId,
                fromDateTime,
                toDateTime,
            };
            admin.getChatMessages(filterParams, (data) => {
                messages.value = data
                    .map((msg) => ({
                    ...msg,
                    isTruncated: true,
                }))
                    .filter((msg) => !/^\b[A-Z]+\b$/.test(msg.body.trim()));
                isLoading.value = false;
                mergeEmployerIntoMessages();
            });
        }
        function loadEmployersAndCustomers() {
            admin.getEmployers((employerData) => {
                employers.value = employerData;
                admin.getCustomers((customerData) => {
                    customers.value = customerData;
                    fetchMessages();
                });
            });
        }
        function applyFilters() {
            const fromDateTime = new Date(`${filters.value.fromDate}T${filters.value.fromTime}`);
            const toDateTime = new Date(`${filters.value.toDate}T${filters.value.toTime}`);
            if (fromDateTime > toDateTime) {
                alert('The From datetime must be less than or equal to the To datetime.');
                return;
            }
            fetchMessages();
        }
        function clearCustomerId() {
            filters.value.customerId = '';
            applyFilters();
        }
        function onRowClicked(row) {
            if (row && row.customerID !== undefined) {
                filters.value.customerId = row.customerID;
                applyFilters();
            }
            else {
                console.warn('Row clicked but customerId is missing or undefined:', row);
            }
        }
        function toggleMessageTruncation(message) {
            const targetMessage = messages.value.find((msg) => msg.id === message.id);
            if (targetMessage) {
                targetMessage.isTruncated = !targetMessage.isTruncated;
            }
            else {
                console.warn('Message not found for toggling truncation:', message);
            }
        }
        onMounted(() => {
            loadEmployersAndCustomers();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[5] || (_cache[5] = [
                            _createElementVNode("div", { class: "spinner" }, null, -1),
                            _createElementVNode("div", { class: "loading-text" }, "Executing query...", -1)
                        ])))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "card-title" }, "Filters", -1)),
                        _createElementVNode("form", {
                            onSubmit: _withModifiers(applyFilters, ["prevent"])
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _cache[6] || (_cache[6] = _createElementVNode("label", { for: "customer-id" }, "Customer ID", -1)),
                                    _createElementVNode("div", _hoisted_7, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "customer-id",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filters.value.customerId) = $event)),
                                            type: "text",
                                            placeholder: "Enter Customer ID",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, filters.value.customerId]
                                        ]),
                                        (filters.value.customerId)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "clear-icon",
                                                onClick: clearCustomerId
                                            }, "×"))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _cache[7] || (_cache[7] = _createElementVNode("label", { for: "from-date" }, "From Date", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "from-date",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filters.value.fromDate) = $event)),
                                        type: "date",
                                        class: "form-input"
                                    }, null, 512), [
                                        [_vModelText, filters.value.fromDate]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "from-time",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filters.value.fromTime) = $event)),
                                        type: "time",
                                        class: "form-input"
                                    }, null, 512), [
                                        [_vModelText, filters.value.fromTime]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _cache[8] || (_cache[8] = _createElementVNode("label", { for: "to-date" }, "To Date", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "to-date",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((filters.value.toDate) = $event)),
                                        type: "date",
                                        class: "form-input"
                                    }, null, 512), [
                                        [_vModelText, filters.value.toDate]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "to-time",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((filters.value.toTime) = $event)),
                                        type: "time",
                                        class: "form-input"
                                    }, null, 512), [
                                        [_vModelText, filters.value.toTime]
                                    ])
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "filter-group filter-button-group" }, [
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-primary"
                                    }, "Apply Filters")
                                ], -1))
                            ])
                        ], 32)
                    ]),
                    _createVNode(AdminTable, {
                        title: "AI Chat Messages",
                        icon: "💬",
                        columns: tableColumns,
                        data: processedMessages.value,
                        loading: false,
                        selectable: true,
                        "empty-message": "No messages found.",
                        onRowSelect: onRowClicked
                    }, {
                        "cell-body": _withCtx(({ row }) => [
                            _createElementVNode("span", {
                                class: _normalizeClass({ 'highlighted-text': row.isHighlighted })
                            }, _toDisplayString(row.displayBody), 3),
                            (row.body && row.body.length > 500)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn-link",
                                    onClick: _withModifiers(($event) => (toggleMessageTruncation(row)), ["stop"])
                                }, _toDisplayString(row.isTruncated ? '[more]' : '[less]'), 9, _hoisted_10))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["data"])
                ])
            ]));
        };
    }
});
